import useBasketInformation from '@hooks/useBasketInformation';

import { BasketCircle } from './styled';

type Props = {
  basketId: string;
  darkTheme?: boolean;
};

const BasketItemsCount = ({ basketId, darkTheme }: Props) => {
  const { itemsInBasket } = useBasketInformation(basketId ?? '', {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  return itemsInBasket ? (
    <BasketCircle darkTheme={darkTheme}>{itemsInBasket}</BasketCircle>
  ) : null;
};

export default BasketItemsCount;
